import { TabularTypeAdapter } from 'app/model/adapters/dataflow/formatAdapters/tabular-type.adapter';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import { SmartsheetSettings } from 'app/model/dataflow/dataset-settings/smartsheet-settings';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(SmartsheetSettings)
})
export class SmartsheetAdapter extends TabularTypeAdapter {
    public async toSourceDSL(setting: SmartsheetSettings): Promise<string[]> {
        const props = [];
        props.push(`store: '${DatasetFormatType.Smartsheet}'`);
        props.push(`format: 'rest'`);
        if (setting.schemaName.expression) {
            props.push(`entityId: ${DataFlowExpressionUtils.wrapExpressionConfigValue(setting.schemaName)}`);
        }
        if (setting.tableName.expression) {
            props.push(`entityType: ${DataFlowExpressionUtils.wrapExpressionConfigValue(setting.tableName)}`);
        }
        return props;
    }

    public async toSourceModel(owner: DataFlowSource, configs: Map<string, string>, handledConfigs: string[]): Promise<SmartsheetSettings> {
        const setting = await super.toSourceModel(owner, configs, handledConfigs) as SmartsheetSettings;
        if (configs.has('entityId')) {
            setting.schemaName = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('entityId'), owner);
            handledConfigs.push('entityId');
        }
        if (configs.has('entityType')) {
            setting.tableName = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('entityType'), owner);
            handledConfigs.push('entityType');
        }
        return setting;
    }

    protected _generateSetting(owner: DataFlowSource | DataFlowSink): SmartsheetSettings {
        const setting = Owned.create<SmartsheetSettings>(SmartsheetSettings.MODEL, owner);
        setting.initialize(undefined);
        return setting;
    }
}
